/* Jonelia – Karussell-Pfeile für .jon-track (Scroll-Snap) */
(function () {
  function initCarousel(root) {
    if (root.dataset.jonReady) return;
    root.dataset.jonReady = '1';
    var track = root.querySelector('.jon-track');
    var prev = root.querySelector('[data-dir="prev"]');
    var next = root.querySelector('[data-dir="next"]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
      var w = first.getBoundingClientRect().width + gap;
      var visible = Math.max(1, Math.floor((track.clientWidth + gap) / w));
      return w * Math.max(1, visible - 1);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var hide = track.scrollWidth <= track.clientWidth + 4;
      if (prev) prev.style.display = hide ? 'none' : '';
      if (next) next.style.display = hide ? 'none' : '';
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initAll() { document.querySelectorAll('[data-jon-carousel]').forEach(initCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);

  /* Tabs (Bestseller): Karussell im gerade sichtbaren Panel neu berechnen */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.jon-tab');
    if (!tab) return;
    setTimeout(function () {
      document.querySelectorAll('[data-jon-carousel]').forEach(function (c) {
        var ev = new Event('scroll');
        var t = c.querySelector('.jon-track');
        if (t) t.dispatchEvent(ev);
      });
    }, 50);
  });
})();

/* ===================== Filterleiste ===================== */
(function(){
  function init(root){
    root = root || document;
    root.querySelectorAll('[data-jon-filterbar]').forEach(function(bar){
      if (bar.dataset.jonInit) return; bar.dataset.jonInit = '1';
      // Query-String (Search&Discovery-Filter, Sortierung) bei Tag-Links beibehalten
      bar.querySelectorAll('a[data-jon-keep-query]').forEach(function(a){
        a.addEventListener('click', function(){
          var qs = window.location.search;
          if (qs) { var url = new URL(a.href); var params = new URLSearchParams(qs); params.delete('page'); params.forEach(function(value, key) { url.searchParams.set(key, value); }); a.href = url.href; }
        });
      });
      // nur ein Dropdown offen; Klick außerhalb schließt
      var dds = bar.querySelectorAll('details.jon-fb__dd');
      dds.forEach(function(d){
        d.addEventListener('toggle', function(){
          if (d.open) dds.forEach(function(o){ if (o !== d) o.open = false; });
          var s = d.querySelector('[data-jon-fb-search]'); if (d.open && s) setTimeout(function(){ s.focus(); }, 30);
        });
      });
      document.addEventListener('click', function(e){
        if (!bar.contains(e.target)) dds.forEach(function(o){ o.open = false; });
      });
      // Suche in langen Listen
      bar.querySelectorAll('[data-jon-fb-search]').forEach(function(inp){
        inp.addEventListener('input', function(){
          var q = inp.value.trim().toLowerCase();
          inp.parentElement.querySelectorAll('[data-search]').forEach(function(el){
            el.style.display = (!q || el.dataset.search.indexOf(q) > -1) ? '' : 'none';
          });
        });
      });
      // S&D-Formular: bei Änderung sofort anwenden (Preis via Button)
      var form = bar.querySelector('[data-jon-fb-form]');
      if (form) {
        form.addEventListener('change', function(e){
          if (e.target.type === 'checkbox') submitClean(form);
        });
        form.addEventListener('submit', function(e){ e.preventDefault(); submitClean(form); });
      }
    });
  }
  function submitClean(form){
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function(el){
      if (!el.name) return;
      if (el.type === 'checkbox' && !el.checked) return;
      if (el.value === '' || el.value == null) return;
      params.append(el.name, el.value);
    });
    var qs = params.toString();
    window.location.href = form.getAttribute('action') + (qs ? '?' + qs : '');
  }
  document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  if (document.readyState !== 'loading') init();
})();

/* ===================== Kollektionsbeschreibung ein-/ausklappen ===================== */
(function(){
  function init(root){
    (root||document).querySelectorAll('[data-jon-desc-toggle]').forEach(function(btn){
      if (btn.dataset.jonInit) return; btn.dataset.jonInit = '1';
      var d = btn.parentElement.querySelector('[data-jon-desc]');
      if (!d) return;
      if (d.scrollHeight <= d.clientHeight + 6) { btn.style.display = 'none'; d.classList.add('is-open'); return; }
      btn.addEventListener('click', function(){
        var open = d.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Weniger anzeigen' : 'Mehr erfahren';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
